// extracted by mini-css-extract-plugin
module.exports = {"orientationMask":"index-orientationMask-4nUub","promptImg":"index-promptImg-5D0wM","showMask":"index-showMask-1sh2t","promptDesc":"index-promptDesc-LG_bB","btn":"index-btn-1RbOu"};